import axios from 'axios';
import Swal from 'sweetalert2'

axios.interceptors.response.use((response) => {
    // Handle the response here
    return response
}, (error) => {
    // Handle errors here
    if (error.response.status == 401 && (window.location.pathname !== '/es' && window.location.pathname !== '/login' && window.location.pathname !== '/en')) {
        window.location.href = '/login'
    }
    return Promise.reject(error)
})

export const generateAxiosInstance = (
    hostApiKey = 'oO60HTCXroXwpsMSYP0cb0cg2hRYNtmSluF',
    baseUrl = null,
    token = null,
) => {
    if (token) {
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    }
    axios.defaults.headers.common['x-api-key'] = hostApiKey;

    // El backend corre en UTC. Mandamos la zona del navegador para que los
    // reportes impriman los timestamps (creado el, pagado el…) con la hora que
    // el usuario vio en su reloj y no 6 horas adelante.
    try {
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        if (tz) axios.defaults.headers.common['X-Time-Zone'] = tz;
    } catch (_) { /* navegador sin Intl: el backend usa su default */ }

    axios.defaults.headers.common['Accept'] = 'application/json';
    axios.defaults.headers.common['Content-Type'] = 'application/json';
    axios.defaults.baseURL = baseUrl;
    return axios;
};